"use client";

import { Breadcrumbs } from "@rangojs/router/client";
import { useHandle, Link } from "@rangojs/router/client";

export function BreadcrumbsNav() {
  const items = useHandle(Breadcrumbs);

  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="mx-auto max-w-7xl px-6 pt-4">
      <ol className="flex items-center gap-1 text-sm text-slate-500">
        {items.map((item, i) => (
          <li key={item.href} className="flex items-center gap-1">
            {i > 0 && <span aria-hidden="true">/</span>}
            {i < items.length - 1 ? (
              <Link
                to={item.href}
                prefetch="viewport"
                className="hover:text-slate-900 hover:underline"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-slate-900">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
